import { useCallback } from 'react'
import { trackEvent } from '@fs/zion-analytics'
import { useQueryParams } from '@fs/zion-router'
import { useR2DispatchContext } from '../../../../providers/r2Provider/R2Context'
import { useOverlayContext } from '../../../../../shared/providers/overlayContextProvider/OverlayContext'

/**
 * Hook that provides the interaction handler for selecting a person in the View Index context.
 * This encapsulates the logic for opening the view index overlay, dispatching actions, etc.
 *
 * @returns {Function} The handlePersonSelect function
 */
export default function useViewIndexPersonSelect() {
  const r2Dispatch = useR2DispatchContext()
  const { openOverlay } = useOverlayContext()
  const { setQuery } = useQueryParams()

  const handlePersonSelect = useCallback(
    (personId, recordId) => {
      openOverlay('viewIndex')
      r2Dispatch({
        type: 'BATCH_DISPATCHES',
        value: [
          { type: 'SET_SELECTED_PERSON_ID', payload: personId },
          { type: 'NAV_SELECT_TO_VIEW', value: { personId, recordId } },
        ],
      })
      trackEvent({
        event_name: 'click_action',
        link_name: `Edit: Select Person`,
      })

      const targetId = personId
      setQuery({ personArk: `/ark:/61903/${targetId}`, action: 'view' })
    },
    [openOverlay, r2Dispatch, setQuery]
  )

  return handlePersonSelect
}
